export const dateToLocal = dateStr => {
    const dateUTCObj = new Date(dateStr)
    const dateLocal = new Date(dateUTCObj.getTime() - 5 * 60 * 60 * 1000)
    const year = dateLocal.getFullYear()
    const month = String(dateLocal.getMonth() + 1).padStart(2, '0')
    const day = String(dateLocal.getDate()).padStart(2, '0')
    const hours = String(dateLocal.getHours()).padStart(2, '0')
    const minutes = String(dateLocal.getMinutes()).padStart(2, '0')
    const formattedDate = `${year}-${month}-${day}`
    const formattedDateAndHour = `${year}-${month}-${day} ${hours}:${minutes}`
    return {
        formattedDateAndHour,
        formattedDate,
    }
}

/**
 * Muestra instantes en hora Colombia. Si el backend envía UTC sin zona
 * (p. ej. "2024-09-13 14:46:39"), se interpreta como UTC para no mostrar
 * la hora “desplazada” respecto a Bogotá.
 */
export const formatDateTimeAmericaBogota = input => {
    if (input == null || input === '') return ''
    const raw = String(input).trim()
    const hasExplicitZone =
        /[zZ]$/.test(raw) ||
        /[+-]\d{2}:\d{2}$/.test(raw) ||
        /[+-]\d{4}$/.test(raw)

    let forParser = raw
    if (!hasExplicitZone && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(raw)) {
        forParser = `${raw.replace(' ', 'T')}Z`
    }

    const d = new Date(forParser)
    if (Number.isNaN(d.getTime())) return raw

    return new Intl.DateTimeFormat('es-CO', {
        timeZone: 'America/Bogota',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    }).format(d)
}
